<template>
  <v-layout wrap>
    <v-flex xs12 pb-0>
      <v-layout wrap align-center>
        <v-flex xs12 mt-3>
          <h1 class="headline">{{ $t('rentsList.title') }}</h1>
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex xs12 sm12 md4>
          <v-layout wrap align-center>
            <v-flex xs12 mt-4 pt-4>
              <v-menu
                ref="menuDate"
                :close-on-content-click="false"
                v-model="menuDate"
                :return-value.sync="rentDate"
                max-width="280px"
                min-width="280px"
                class="pr-4 mt-2"
                transition="scale-transition"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-on="on"
                    v-model="rentDate"
                    :label="$t('common.fields.rentDate')"
                    readonly
                    class="date"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="rentDate"
                  color="primary lighten-1"
                  :locale="$i18n.locale"
                  width="280"
                  @input="changeDate"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs12>
              <v-layout wrap align-center>
                <v-flex xs12 v-for="type in rentsTypes" :key="type.id">
                  <v-checkbox
                    :label="type.title"
                    :input-value="type.value"
                    color="primary"
                    class="mt-0"
                    @change="chooseRentType(type.id)"
                  ></v-checkbox>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 sm12 md8 mt-4>
          <v-layout wrap align-center>
            <v-flex xs12 sm12 mt-4>
              <v-layout wrap align-center class="search-wrapper">
                <v-text-field
                  class="search"
                  ref="search"
                  v-model="search"
                  :placeholder="$t('rentsList.search.placeholder')"
                  autocomplete="off"
                  solo
                ></v-text-field>
                <v-btn
                  type="button"
                  class="search-btn warning mb-4"
                  depressed
                  large
                  @click="searchRents"
                >
                  {{ $t('common.btns.search') }}
                </v-btn>
              </v-layout>
            </v-flex>
            <v-flex xs12 sm12 class="filter-wrapper">
              <v-select
                :items="rentsStatuses"
                v-model="rentStatus"
                :label="$t('common.fields.status')"
                item-text="title"
                item-value="id+table"
                class="filter"
                @change="changeRentsStatus"
                return-object
              ></v-select>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs12>
      <v-data-table
        :items="rentsList.items"
        :headers="headers"
        :loading="isLoading"
        :loading-text="$t('common.table.dataIsLoading')"
        :server-items-length="2"
        :mobile-breakpoint="100"
        class="table-custom rentsList small mb-4"
        hide-default-footer
      >
        <template slot="item" slot-scope="{ item }">
          <tr
            :key="item.carId + item.id"
            :class="{
              canceled:
                item.statusId === 3 ||
                item.statusId === 4 ||
                item.statusId === 5,
              finished: item.statusId === 2,
              'no-click':
                !item.id && role !== 'admin' && role !== 'rentManager',
            }"
            @click="goToItemDetailsPage(item)"
          >
            <td>{{ item.num }}</td>
            <td class="text-xs-left">{{ item.number }}</td>
            <td class="text-xs-left">{{ item.brand }}</td>
            <td class="text-xs-left">{{ item.model }}</td>
            <td class="text-xs-left">{{ item.name }}</td>
            <td class="text-xs-left company">
              <div>{{ item.phone }}</div>
              <div>{{ item.secondPhone }}</div>
            </td>
            <td class="text-xs-left">
              <div>{{ item.date }}</div>
              <div>{{ item.type }}</div>
            </td>
            <td class="text-xs-left">
              <div>{{ item.rentStart }}</div>
              <div v-if="item.rentPreStopped">/ {{ item.rentPreStopped }}</div>
            </td>
            <td class="text-xs-left">{{ item.price }}</td>
            <td class="text-xs-left">
              <div>{{ item.status }}</div>
              <div v-if="item.acceptedByManager" class="font-weight-black">
                {{ $t('common.labels.acceptedByManager') }}
              </div>
            </td>
          </tr>
        </template>
        <template slot="no-data">{{ $t('common.table.noData') }}</template>
      </v-data-table>
      <div v-if="paginationPage" class="text-xs-center">
        <v-pagination
          :value="paginationPage"
          :length="paginationLength"
          @input="choosePaginatorPage($event)"
        ></v-pagination>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';

export default {
  name: 'RentsListPage',
  components: {},
  data() {
    return {
      search: '',
      headers: [
        { text: this.$t('common.number'), sortable: false },
        { text: this.$t('rentsList.tableHeaders.number'), sortable: false },
        { text: this.$t('rentsList.tableHeaders.brand'), sortable: false },
        { text: this.$t('rentsList.tableHeaders.model'), sortable: false },
        { text: this.$t('rentsList.tableHeaders.name'), sortable: false },
        { text: this.$t('rentsList.tableHeaders.phone'), sortable: false },
        {
          text: this.$t('rentsList.tableHeaders.dateAndShift'),
          sortable: false,
        },
        { text: this.$t('rentsList.tableHeaders.rentTime'), sortable: false },
        { text: this.$t('rentsList.tableHeaders.price'), sortable: false },
        { text: this.$t('rentsList.tableHeaders.status'), sortable: false },
      ],
      defaultStatus: {
        id: '',
        table: '',
        title: this.$t('rents.allRents'),
      },
      rentStatus: {
        id: '',
        table: '',
        title: this.$t('rents.allRents'),
      },
      rentDate: new Date().toISOString().substr(0, 10),
      menuDate: false,
    };
  },
  watch: {
    /* eslint-disable */
    '$i18n.locale': async function() {
      await this.fetchRentsProperties();
      await this.fetchRents({
        page: this.paginationPage,
        searchString: this.search,
        rentStatus: JSON.stringify(this.rentStatus),
        rentDate: this.rentDate,
        rentType: this.rentsTypes
          .filter((item) => !!item.value)
          .map((item) => item.id)
          .toString(),
      });
      this.$vuetify.goTo(0, 'easeInOutCubic');
    },
  },
  computed: {
    ...mapGetters({
      isLoading: 'global/getLoader',
      rentsList: 'rent/getRentsListData',
      statuses: 'rent/getRentsStatuses',
      types: 'rent/getRentsTypes',
      role: 'global/getRole',
    }),
    rentsStatuses() {
      return [this.defaultStatus].concat(this.statuses);
    },
    rentsTypes() {
      const rentsTypesArr = [];
      this.types.forEach((rent) => {
        const item = {
          id: rent.id,
          title: rent.title,
          value: true,
        };
        rentsTypesArr.push(item);
      });
      return rentsTypesArr;
    },
    paginationLength() {
      return this.rentsList.lastPage;
    },
    paginationPage() {
      if (this.rentsList.currentPage === 1 && this.rentsList.lastPage === 1) {
        return 0;
      }
      return this.rentsList.currentPage;
    },
  },
  async created() {
    await this.fetchRentsProperties();
    await this.fetchRents({
      page: 1,
      searchString: this.search,
      rentStatus: JSON.stringify(this.rentStatus),
      rentDate: this.rentDate,
      rentType: this.rentsTypes
        .filter((item) => !!item.value)
        .map((item) => item.id)
        .toString(),
    });
  },
  destroyed() {
    this.setRentsListData({});
    this.setStatuses([]);
    this.setTypes([]);
    this.clearAlertError();
  },
  methods: {
    ...mapActions({
      fetchRents: 'rent/fetchRentsListData',
      fetchRentsProperties: 'rent/fetchRentsProperties',
    }),
    ...mapMutations({
      setRentsListData: 'rent/setRentsListData',
      setStatuses: 'rent/setRentsStatuses',
      setTypes: 'rent/setRentsTypes',
      clearAlertError: 'global/clearAlertError',
    }),
    async searchRents() {
      await this.fetchRents({
        page: 1,
        searchString: this.search,
        rentStatus: JSON.stringify(this.rentStatus),
        rentDate: this.rentDate,
        rentType: this.rentsTypes
          .filter((item) => !!item.value)
          .map((item) => item.id)
          .toString(),
      });
    },
    async choosePaginatorPage(page) {
      await this.fetchRents({
        page,
        searchString: this.search,
        rentStatus: JSON.stringify(this.rentStatus),
        rentDate: this.rentDate,
        rentType: this.rentsTypes
          .filter((item) => !!item.value)
          .map((item) => item.id)
          .toString(),
      });
      this.$vuetify.goTo(0, 'easeInOutCubic');
    },
    async changeRentsStatus() {
      await this.searchRents();
    },
    async changeDate() {
      this.$refs.menuDate.save(this.rentDate);
      await this.searchRents();
    },
    async chooseRentType(typeId) {
      const position = this.rentsTypes.map((item) => item.id).indexOf(typeId);
      this.rentsTypes[position].value = !this.rentsTypes[position].value;
      await this.searchRents();
    },
    goToItemDetailsPage(item) {
      const itemRoute = item.id ? `/rents/${item.id}` : `/autos/${item.carId}`;
      this.$router.push(itemRoute);
    },
  },
};
</script>

<style lang="scss" scoped>
.search-wrapper {
  .search {
    margin-right: -12px;
    margin-bottom: -12px;
    max-width: 480px;

    @media (max-width: 480px) {
      margin-right: 0px;
      margin-bottom: -12px;
      max-width: 100%;
    }
  }

  @media (max-width: 480px) {
    flex-direction: column;

    .search {
      width: 100%;
    }
  }
}
.date {
  max-width: 200px;
}
.canceled {
  background: rgba(233, 30, 30, 0.25);
}
.finished {
  background: rgba(227, 224, 224, 0.25);
  color: #808080;
}
.no-click {
  pointer-events: none;
}
</style>
